module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAD1BMVEXb4+7pmaAAM4jMESL///8p/s47AAAAAnRSTlPGxpk02nUAAAAySURBVEjH7csxAQAgDAOwWcACFrCAf01YWHmX/KkdUxRF6ZYPN6YoytCyYnViiqIoTQ9N/YeVxQLjRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag/100px-Flag_of_Valledupar.svg.png
// module id = gRZo
// module chunks = 1